import { Component, OnInit } from '@angular/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService, ProductService } from '@app/core';
import { Category } from '@core/model/category.model';
import { Product } from '@core/model/product.model';

@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.css']
})
export class PedidosComponent implements OnInit {
  inicio: string;
  final: string;
  existencia: any;
  buscarForm: FormGroup;
  categories: Category[];
  products: Product[];
  isLoading = false;

  todos: number;

  constructor(
    private reporteService: ReporteService,
    private categoryService: CategoryService,
    private productoService: ProductService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.listData2();
    this.ListarExistencia();
  }

  createForm() {
    this.buscarForm = this.formBuilder.group({
      inicio: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      fin: [new Date().toISOString().substring(0, 10), [Validators.required]],
      categoria: ['', [Validators.nullValidator]],
      producto: ['', [Validators.nullValidator]]
      /*   categoria: ['',[Validators.required]],
      producto:['',[Validators.required]]*/
    });
  }
  getSelectedProduct(event: Product) {
    // alert(event);

    console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    // console.log(i);
    this.todos = event.producto_id;
    //  this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }

  listData2() {
    // listando cattegorias

    // listtando producto
    this.productoService.getProductosExistencia().subscribe(
      data => {
        // console.log(data);
        this.products = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  listData() {
    // listando cattegorias
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    const data2 = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia,
      categoria_id: 0
    };
    // listtando producto
    this.reporteService.productosPedidos(data2).subscribe(
      data => {
        console.log(data);
        this.existencia = data;

        //  this.products = data;
      },
      error => {
        console.log(error);
      }
    );
  }
  buscarExistencia() {
    let data = {};

    if (this.todos !== undefined) {
      data = {
        producto_id: this.buscarForm.value.producto,
        categoria_id: this.buscarForm.value.categoria,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    } else {
      data = {
        producto_id: 0,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    }

    this.reporteService.productosPedidos(data).subscribe(
      data2 => {
        // console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  ListarExistencia() {
    /* const data = {
       fecha_inicio: '2019/11/02',
       fecha_final: '2019/12/02'
     };*/
    const fechaActual = new Date();
    const dia = fechaActual.getDate().toString();
    const mes = (fechaActual.getMonth() + 1).toString();
    const anio = fechaActual.getFullYear().toString();
    // alert(mes);
    const data = {
      fecha_inicio: anio + '/' + mes + '/' + dia,
      fecha_final: anio + '/' + mes + '/' + dia,
      categoria_id: 0
    };
    console.log(data);
    // alert(this.i/**/nicio);
    this.reporteService.productosPedidos(data).subscribe(
      data2 => {
        //    console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  buscarExistencia2() {
    let data = {};
    console.log(this.todos);
    if (this.todos !== undefined) {
      data = {
        producto_id: this.buscarForm.value.producto,
        categoria_id: this.buscarForm.value.categoria,
        fecha_inicio: this.buscarForm.value.inicio,
        fecha_final: this.buscarForm.value.fin
      };
    }

    console.log(data);
    this.reporteService.existencia(data).subscribe(
      data2 => {
        //  console.log(data2);
        this.existencia = data2;
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  checkStatus(stock: Number, lim: Number) {
    if (stock <= lim) {
      return false;
    } else {
      return true;
    }
  }
}
